// extracted by mini-css-extract-plugin
export default {"food":"Food_food__h0aJ3"};